import { render, staticRenderFns } from "./RbModal.vue?vue&type=template&id=608c27ff"
import script from "./RbModal.vue?vue&type=script&lang=js"
export * from "./RbModal.vue?vue&type=script&lang=js"
import style0 from "./RbModal.vue?vue&type=style&index=0&id=608c27ff&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports